import { MarketDataContent } from './market-data-content';

export function MarketDataPage() {
  return <MarketDataContent />;
}
